module.exports = __webpack_public_path__ + "assets/images/searchcea452c937ed6a4b5055e22b09b3ce31.svg";